import { render, staticRenderFns } from "./sms-price.vue?vue&type=template&id=7c08577e&scoped=true"
import script from "./sms-price.vue?vue&type=script&lang=js"
export * from "./sms-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08577e",
  null
  
)

export default component.exports